import types from '../actionTypes';

export const dragPin = (id, payload) => ({
    type: types.DRAG_PIN,
    meta: {
        id,
    },
    payload,
});
